package com.vamvisions.main.contact.domain.model

/**
 * A message for the owner from the contact form. [name] is null when left empty, [topic] when none was chosen.
 * [website] is the hidden honeypot field, which people leave empty.
 */
data class ContactMessage(
    val name: String?,
    val email: String,
    val message: String,
    val website: String?,
    val topic: ContactTopic? = null,
)
